<template>
  <div>
    <CCard>
      <CCardHeader>
        <div class="d-flex justify-content-between align-items-center">
          <strong>АБ тестирование</strong>
          <CButton
            color="primary"
            variant="outline"
            @click="$router.push('/ab-tests/create')"
          >
            <CIcon name="cil-plus" class="mr-1" />
            Создать тест
          </CButton>
        </div>
      </CCardHeader>
      <CCardBody>
        <CDataTable
          :items="abTests"
          :fields="fields"
          table-filter
          items-per-page-select
          :items-per-page="25"
          pagination
          sorter
          hover
          striped
          :loading="loading"
        >
          <template #active="{ item }">
            <td>
              <CBadge :color="item.active ? 'success' : 'secondary'">
                {{ item.active ? 'Активен' : 'Неактивен' }}
              </CBadge>
            </td>
          </template>
          
          <template #traffic_allocation="{ item }">
            <td>{{ item.traffic_allocation }}%</td>
          </template>
          
          <template #variants_count="{ item }">
            <td>
              <CBadge color="info">
                {{ item.variants ? item.variants.length : 0 }} вариантов
              </CBadge>
            </td>
          </template>
          
          <template #created_at="{ item }">
            <td>{{ formatDate(item.created_at) }}</td>
          </template>
          
          <template #actions="{ item }">
            <td>
              <div class="d-flex">
                <CButton
                  color="info"
                  variant="outline"
                  size="sm"
                  class="mr-1"
                  @click="$router.push(`/ab-tests/${item.id}`)"
                >
                  <CIcon name="cil-pencil" />
                </CButton>
                <CButton
                  color="success"
                  variant="outline"
                  size="sm"
                  class="mr-1"
                  @click="$router.push(`/ab-tests/${item.id}/statistics`)"
                >
                  <CIcon name="cil-chart-line" />
                </CButton>
                <CButton
                  color="danger"
                  variant="outline"
                  size="sm"
                  @click="deleteTest(item)"
                >
                  <CIcon name="cil-trash" />
                </CButton>
              </div>
            </td>
          </template>
        </CDataTable>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'AbTestsList',
  data() {
    return {
      loading: false,
      abTests: [],
      fields: [
        { key: 'id', label: 'ID', _style: 'width:80px;' },
        { key: 'name', label: 'Название', sortable: true },
        { key: 'key', label: 'Ключ', sortable: true },
        { key: 'active', label: 'Статус', sortable: true },
        { key: 'traffic_allocation', label: 'Трафик' },
        { key: 'variants_count', label: 'Варианты' },
        { key: 'created_at', label: 'Создан', sortable: true },
        { key: 'actions', label: 'Действия', _style: 'width:150px;', sorter: false, filter: false }
      ]
    }
  },
  async mounted() {
    await this.fetchAbTests()
  },
  methods: {
    async fetchAbTests() {
      this.loading = true
      try {
        const { data } = await this.$http.get('/ab-tests')
        this.abTests = data
      } catch (error) {
        this.$root.$emit('showError', 'Ошибка загрузки A/B тестов')
        console.error(error)
      }
      this.loading = false
    },
    
    async deleteTest(test) {
      const confirmed = confirm(`Вы уверены, что хотите удалить тест "${test.name}"?\n\nЭто действие удалит все варианты и статистику теста.\nДанное действие нельзя отменить.`)
      
      if (confirmed) {
        try {
          await this.$http.delete(`/ab-tests/${test.id}`)
          this.$root.$emit('showSuccess', 'Тест успешно удален')
          await this.fetchAbTests()
        } catch (error) {
          if (error.response && error.response.data && error.response.data.message) {
            this.$root.$emit('showError', error.response.data.message)
          } else {
            this.$root.$emit('showError', 'Ошибка удаления теста')
          }
          console.error(error)
        }
      }
    },
    
    formatDate(date) {
      return moment(date).format('DD.MM.YYYY HH:mm')
    }
  }
}
</script> 